import { render, staticRenderFns } from "./wjdc.vue?vue&type=template&id=48283c32&scoped=true&"
import script from "./wjdc.vue?vue&type=script&lang=js&"
export * from "./wjdc.vue?vue&type=script&lang=js&"
import style0 from "./wjdc.vue?vue&type=style&index=0&id=48283c32&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48283c32",
  null
  
)

export default component.exports